// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__6wQGw"};